export const getModal = (state) =>state.modal;
export const getState = (state) =>state.modal.state;